import { render, staticRenderFns } from "./Modals.vue?vue&type=template&id=46175704&scoped=true"
import script from "./Modals.vue?vue&type=script&setup=true&lang=js"
export * from "./Modals.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Modals.vue?vue&type=style&index=0&id=46175704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46175704",
  null
  
)

export default component.exports